/* src/app/shared/controls/message-dialog/message-dialog.component.scss */
@font-face {
  font-family: "Noto Sans";
  src: url("./media/NotoSans-Regular-ZNAPSC3M.ttf");
  src:
    url("./media/NotoSans-Regular-ZNAPSC3M.ttf") format("truetype"),
    url("./media/NotoSans-BoldItalic-3JQC5OZS.ttf") format("truetype"),
    url("./media/NotoSans-Bold-GRYZZLHD.ttf") format("truetype"),
    url("./media/NotoSans-Italic-5X45VU5J.ttf") format("truetype"),
    url("./media/NotoSans-Light-JP6O7GL4.ttf") format("truetype"),
    url("./media/NotoSans-LightItalic-5YVFDRZM.ttf") format("truetype"),
    url("./media/NotoSans-Medium-NN452WKZ.ttf") format("truetype"),
    url("./media/NotoSans-MediumItalic-ZRI6HATP.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Marsh Serif";
  src: url("./media/MarshSerif-Regular-FTLVEPD5.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Marsh Serif";
  src: url("./media/MarshSerif-Italic-H4EFZXHC.woff2") format("woff2");
  font-weight: normal;
  font-style: italic;
}
body {
  font-family: "Noto Sans", sans-serif;
}
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(1.5px);
  backdrop-filter: blur(1.5px);
}
.dialog-container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 250px;
  border-radius: 20px;
  background-color: white;
  transform: translate(-50%, -50%);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  animation: dialog-pop 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}
.dialog-border {
  padding: 10px 20px 20px;
}
.dialog-header {
  height: 70px;
}
.icon-container {
  height: 70px;
  width: 70px;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 45px;
  border-style: solid;
  border-width: 3px;
}
.info-icon-container {
  border-color: #006f8a;
  background-color: rgba(0, 150.652173913, 189, 0.4196078431);
}
.success-icon-container {
  border-color: #17c280;
  background-color: rgba(38.6497695853, 229.3502304147, 156.8617511521, 0.3764705882);
}
.error-icon-container {
  border-color: #e34c5e;
  background-color: rgba(249.5987261146, 159.127388535, 154.4012738854, 0.3490196078);
}
.warning-icon-container {
  border-color: #f7914d;
  background-color: rgba(249.1935483871, 175.1612903226, 125.8064516129, 0.368627451);
}
.dialog-icon {
  width: 70px;
  margin-top: 20px;
  text-align: center;
  font-size: 30px;
}
.info-dialog-icon {
  color: #006f8a;
}
.success-dialog-icon {
  color: #17c280;
}
.error-dialog-icon {
  color: #e34c5e;
}
.warning-dialog-icon {
  color: #f7914d;
}
.dialog-content {
  text-align: center;
  height: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.dialog-content-header {
  font-size: 20px;
  font-family: "Noto Sans", sans-serif;
}
.dialog-content-message {
  padding: 10px 0px;
  font-size: 15px;
  font-family: "Noto Sans", sans-serif;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  height: 40px;
}
button {
  margin-right: 5px;
  margin-left: 5px;
}
@keyframes dialog-pop {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.5);
  }
  80% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
/*# sourceMappingURL=message-dialog.component-EBKTXZTI.css.map */
